import bbox from '@turf/bbox';
import { useCallback, useRef, useState } from 'react';

export const useMapState = (boundry) => {
  const [initialBoundsSet, setInitialBoundsSet] = useState(false);
  const viewportState = useState({
    latitude: -40.9753799,
    longitude: 176.8903929,
    zoom: 4,
    height: 400,
    width: '100%'
  });
  const mapRef = useRef();
  const mapRefWrapper = useCallback((node) => {
    if (node) {
      if (boundry && !initialBoundsSet) {
        fitBounds(node);
        setInitialBoundsSet(true);
      }
    }
    mapRef.current = node;
  }, []);

  const fitBounds = (map) => {
    const features = boundry;
    if (features) {
      // calculate the bounding box of the feature
      const [minLng, minLat, maxLng, maxLat] = bbox(features);

      map.fitBounds(
        [
          [minLng, minLat],
          [maxLng, maxLat]
        ],
        { padding: 50, duration: 500 }
      );
    }
  };

  return [viewportState, mapRefWrapper, fitBounds];
};
